module.exports = __webpack_public_path__ + "img/magento-modules-customization_medium.b0c2acdc.jpg";